import { render, staticRenderFns } from "./quotationCustomerDiscountDetail.vue?vue&type=template&id=2ca2fb40&scoped=true"
import script from "./quotationCustomerDiscountDetail.vue?vue&type=script&lang=js"
export * from "./quotationCustomerDiscountDetail.vue?vue&type=script&lang=js"
import style0 from "./quotationCustomerDiscountDetail.vue?vue&type=style&index=0&id=2ca2fb40&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ca2fb40",
  null
  
)

export default component.exports